import { ErrorMessagesService } from './error-messages.service';

export default angular
  .module('sfMobile.services.error-messages', [
    'pascalprecht.translate',
    'sfMobile.services.app-message',
    'sfMobile.constants.error-codes',
  ])
  .service('errorMessagesService', ErrorMessagesService).name;
